import { render, staticRenderFns } from "./NormativaLista.vue?vue&type=template&id=2718f014&scoped=true"
import script from "./NormativaLista.vue?vue&type=script&lang=js"
export * from "./NormativaLista.vue?vue&type=script&lang=js"
import style0 from "./NormativaLista.vue?vue&type=style&index=0&id=2718f014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2718f014",
  null
  
)

export default component.exports